const getFormUrlEncodedRequestData = (data = {}) => {
  const formBody = [];
  Object.keys(data).forEach((property) => {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(data[property]);
    formBody.push(`${encodedKey}=${encodedValue}`);
  });
  return formBody.join('&');
};
export default getFormUrlEncodedRequestData;
